export default __webpack_public_path__ + "static/promotionals-33e0fc11ed9a63bd54faf5c49934c96d.png";